export default [
    {
        id: 1,
        avatar: "https://i.pravatar.cc/150?img=1",
        name: "Vansh Saini",
        role: "Worked Desk 1",
        projects: ["SG", "PQ", "CB"],
        time: "113:27:25",
        activity: 50,
        idle: 11,
        notes: 5,
        details: [
            {
                date: "Tue, Apr 1, 2025",
                code: "SG",
                name: "John Doe",
                avatar: "https://i.pravatar.cc/150?img=2", // Optional image URL
                desk: "Social Media Strategist",
                time: "9:32:37",
                activity: 50,
                idle: 9,
                notes: "2 Notes"
            },
            {
                date: "",
                code: "PQ",
                name: "Jane Smith", // No avatar - will show initials "JS"
                avatar: "https://i.pravatar.cc/150?img=3",
                desk: "UX Designer",
                time: "8:44:49",
                activity: 50,
                idle: 9,
                notes: "-"
            },
            
        ]
    },
    {
        id: 2,
        avatar: "https://i.pravatar.cc/150?img=4",
        name: "Dianne Russell",
        role: "Worked Desk 2",
        projects: ["SG", "PQ", "CB"],
        time: "113:27:25",
        activity: 50,
        idle: 11,
        notes: 5,
        details: [
            {
                date: "Tue, Apr 1, 2025",
                code: "SG",
                name: "John Doe",
                avatar: "https://i.pravatar.cc/150?img=5", // Optional image URL
                desk: "Product Manager",
                time: "9:32:37",
                activity: 50,
                idle: 9,
                notes: "2 Notes"
            },
            {
                date: "",
                code: "PQ",
                name: "Jane Smith", // No avatar - will show initials "JS"
                avatar: "https://i.pravatar.cc/150?img=6",
                desk: "SEO Specialist",
                time: "8:44:49",
                activity: 50,
                idle: 9,
                notes: "-"
            },
           
        ]
    },
];